module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "basic-text-frame"
  }, [_c('p', {
    staticClass: "chapterheader",
    attrs: {
      "id": "toc_marker-2-7"
    }
  }, [_c('span', {
    staticClass: "chapterheader1"
  }, [_vm._v("Chapter 7")])])]), _vm._v(" "), _c('div', {
    staticClass: "basic-text-frame"
  }, [_c('p', {
    staticClass: "bodytext2"
  }, [_c('span', {
    staticClass: "dedication1"
  }, [_vm._v("The next morning, I was pleasantly surprised that Korine showed up to clean, just as she said she would. She brought old newspapers to wipe the windows dry, which worked out amazingly well. I showed her the two new porches with their new windows and slate floors.")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext2"
  }, [_c('span', {
    staticClass: "dedication1"
  }, [_vm._v("“Oh, Lily, I never thought these rooms could be so beautiful,” she exclaimed. “I remember the first time I saw them. There was a big wasps’ nest in the corner of the ceiling over there. I’m glad to see that’s gone.” ")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext2"
  }, [_c('span', {
    staticClass: "dedication1"
  }, [_vm._v("“I think the whole house has potential, but I’ve always liked spending time in a room that brings a little nature inside. I guess I miss my porch at The Hill. I spent a lot of mornings and sleepless nights on that porch.” ")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext2"
  }, [_c('span', {
    staticClass: "dedication1"
  }, [_vm._v("Korine nodded as she listened intently. Then she said, “Well, I don’t have all day, so I’d better start upstairs. You aren’t going anywhere, are you?” ")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext2"
  }, [_c('span', {
    staticClass: "dedication1"
  }, [_vm._v("I chuckled as I shook my head. “I’ll be here all day, so don’t worry. I have some tuna salad made up if you get hungry and want lunch. I’ll leave you to your work. I need to get the shop open.”")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext2"
  }, [_c('span', {
    staticClass: "dedication1"
  }, [_vm._v("“I hate to ask, Lily, but are you feeling okay? I hate to bring up your accident, but you look a little peaked.”")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext2"
  }, [_c('span', {
    staticClass: "dedication1"
  }, [_vm._v("“I know there are some reminders of it all, but I think I’m healing pretty well. I’m just still sore.”")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext2"
  }, [_c('span', {
    staticClass: "dedication1"
  }, [_vm._v("“You’re just lucky to be alive!” Korine said as she started up the stairs.")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext2"
  }, [_c('span', {
    staticClass: "dedication1"
  }, [_vm._v("When I took the rocker to the front porch, the wind was fierce. I wondered if the quilt would stay put, so I put a lantern on top of the bright green-and-white beauty just to make sure. Kitty pulled up just as I was about to go back in. “Good morning!” I said, shivering. “Come on in. I have hot coffee.”")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext2"
  }, [_c('span', {
    staticClass: "dedication1"
  }, [_vm._v("“No thanks, Lily. I just left a meeting at Kate’s Coffee.”")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext2"
  }, [_c('span', {
    staticClass: "dedication1"
  }, [_vm._v("“You have to take a quick look at my porches before you go,” I said, leading her to the porch.")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext2"
  }, [_c('span', {
    staticClass: "dedication1"
  }, [_vm._v("“Not a very good day to enjoy it, but how lovely for you.”")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext2"
  }, [_c('span', {
    staticClass: "dedication1"
  }, [_vm._v("“It will be. Vic ordered some furniture through the gallery for me. He was able to get a nice discount.”")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext2"
  }, [_c('span', {
    staticClass: "dedication1"
  }, [_vm._v("“Great! Hey, the reason I stopped by is to ask whether you were going to do any kind of open house for Christmas. We’re getting a list of events together to promote the holidays.”")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext2"
  }, [_c('span', {
    staticClass: "dedication1"
  }, [_vm._v("“How nice! I suppose I should since I didn’t have a grand opening or anything.”")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext2"
  }, [_c('span', {
    staticClass: "dedication1"
  }, [_vm._v("“Yes, you should. It’s no big deal. Just do a little Christmas decorating and have some hot cider or refreshments. It’s helpful if there are a lot of us having something on the same night to make it worthwhile for folks. If you’d like to have a little drawing for a giveaway, that helps bring customers in, too.”")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext2"
  }, [_c('span', {
    staticClass: "dedication1"
  }, [_vm._v("“Sure, put me down, but I leave for Green Bay to have Christmas on the twenty-third.”")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext2"
  }, [_c('span', {
    staticClass: "dedication1"
  }, [_vm._v("“No problem. We were thinking of doing it on Saturday the twenty-first.”")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext2"
  }, [_c('span', {
    staticClass: "dedication1"
  }, [_vm._v("As soon as I signed on the dotted line, Kitty was on her way. I felt she did have my best interests at heart as a fellow shop owner. I was naive about so many things.")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext2"
  }, [_c('span', {
    staticClass: "dedication1"
  }, [_vm._v("I went upstairs to check on Korine and noticed that she had made great progress. “Have you had any ghost sightings up here, Korine?” I teased.")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext2"
  }, [_c('span', {
    staticClass: "dedication1"
  }, [_vm._v("“Lily, I know there’s something in this house. I can feel it. Aren’t you ever scared?”")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext2"
  }, [_c('span', {
    staticClass: "dedication1"
  }, [_vm._v("“I guess not. My niece said she felt someone here, so you’re not the only one. I really appreciate your help today. It’s hard to wait on customers and get anything done around the house.”")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext2"
  }, [_c('span', {
    staticClass: "dedication1"
  }, [_vm._v("“I love seeing all the pretty things you and Carrie Mae have. My grandmother had some fancy things that we were never allowed to touch. They didn’t end up in my house when she died, that’s for sure.”")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext2"
  }, [_c('span', {
    staticClass: "dedication1"
  }, [_vm._v("“What do you like in particular?” ")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext2"
  }, [_c('span', {
    staticClass: "dedication1"
  }, [_vm._v("Korine paused, giving the matter some thought. Then she said, “Oh, most everything, but I’m partial to pretty dishes. I can’t imagine eating off such things. We just bought plain white when I married Harold, and I still have them to this day. I love washing them up, but I’m always afraid I’ll break something.”")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext2"
  }, [_c('span', {
    staticClass: "dedication1"
  }, [_vm._v("I left her to do her work, but her comments made me think back to the time when I was a little girl playing house with miniature dishes. I guess most little girls have those memories.")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext1"
  }, [_c('span', {
    staticClass: "char-style-override2"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "basic-text-frame"
  }, [_c('p', {
    staticClass: "bodytext"
  }, [_c('span', {
    staticClass: "testimonial-body"
  })]), _vm._v(" "), _c('p', {
    staticClass: "bodytext1"
  }, [_c('span', {
    staticClass: "testimonial-body"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "basic-text-frame"
  }, [_c('p', {
    staticClass: "bodytext"
  }, [_c('span', {
    staticClass: "testimonial-body"
  })]), _vm._v(" "), _c('p', {
    staticClass: "bodytext1"
  }, [_c('span', {
    staticClass: "testimonial-body"
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-12f6afee","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/Lily_Girl_split10.vue
// module id = 90
// module chunks = 0